import { TranscriptionExtendedSegmentation } from 'flow/types/CallRecord';

interface Props {
    segmentations?: TranscriptionExtendedSegmentation[];
}

const TranscriptionSegments = ({ segmentations }: Props) => {
    return (
        <div className="flex flex-col gap-4">
            {segmentations?.map((segment) => (
                <div key={`segment-${segment.index}`}>
                    <div className="text-xs text-gray-400">
                        {`${segment.speaker} · ${segment.startTime}`}
                    </div>
                    <div>{segment.text}</div>
                </div>
            ))}
        </div>
    );
};

export default TranscriptionSegments;
